import { useQueryClient } from "@tanstack/react-query"

import WizardHeader from "../../components/WizardHeader"
import WizardFooter from "../../components/WizardFooter"
import { useAccountId } from "../../hooks"

export interface LiabilityInsurancePropertyCompletedProps {
  handlePrevious: () => void
  handleNext: () => void
}

const LiabilityInsurancePropertyCompleted = ({
  handlePrevious,
  handleNext,
}: LiabilityInsurancePropertyCompletedProps) => {
  const accountId = useAccountId()
  const queryClient = useQueryClient()

  return (
    <div className="pt-10 lg:pt-13 pb-31">
      <WizardHeader
        eyebrow="Your NCX Guide"
        heading="Property step completed"
      />

      <div className="container w-[752px] mt-4 px-5 lg:px-10">
        <button
          type="button"
          className="btn2 btn2-primary font-bold tracking-[0.32px] whitespace-nowrap"
          onClick={() => {
            queryClient.invalidateQueries({
              queryKey: ["accounts", accountId, "insurance_wizard"],
            })
          }}
          data-testid="refetch-button"
        >
          Restart
        </button>
      </div>

      <WizardFooter>
        <div className="flex gap-4 ml-auto">
          <button
            type="button"
            className="liability-insurance-property-go-back-button btn2 btn2-outline-primary font-bold tracking-[0.32px] whitespace-nowrap"
            onClick={handlePrevious}
            data-testid="completed-go-back-button"
          >
            Go Back
          </button>

          <button
            type="button"
            className="liability-insurance-property-next-button btn2 btn2-primary font-bold tracking-[0.32px] whitespace-nowrap"
            onClick={handleNext}
            data-testid="completed-next-button"
          >
            Next
          </button>
        </div>
      </WizardFooter>
    </div>
  )
}

export default LiabilityInsurancePropertyCompleted
